/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "heri",
        "0": "hodie",
        "1": "deman",
        "future": {
          "one": "in {0} die",
          "other": "in {0} dies"
        },
        "past": {
          "one": "{0} die retro",
          "other": "{0} dies retro"
        }
      },
      "day-narrow": {
        "-1": "heri",
        "0": "hodie",
        "1": "deman",
        "future": {
          "one": "in {0} die",
          "other": "in {0} dies"
        },
        "past": {
          "one": "{0} die retro",
          "other": "{0} dies retro"
        }
      },
      "day-short": {
        "-1": "heri",
        "0": "hodie",
        "1": "deman",
        "future": {
          "one": "in {0} die",
          "other": "in {0} dies"
        },
        "past": {
          "one": "{0} die retro",
          "other": "{0} dies retro"
        }
      },
      "hour": {
        "0": "iste hora",
        "future": {
          "one": "in {0} hora",
          "other": "in {0} horas"
        },
        "past": {
          "one": "{0} hora retro",
          "other": "{0} horas retro"
        }
      },
      "hour-narrow": {
        "0": "iste hora",
        "future": {
          "one": "in {0} hr.",
          "other": "in {0} hr."
        },
        "past": {
          "one": "{0} hr. retro",
          "other": "{0} hr. retro"
        }
      },
      "hour-short": {
        "0": "iste hora",
        "future": {
          "one": "in {0} hr.",
          "other": "in {0} hr."
        },
        "past": {
          "one": "{0} hr. retro",
          "other": "{0} hr. retro"
        }
      },
      "minute": {
        "0": "iste minuta",
        "future": {
          "one": "in {0} minuta",
          "other": "in {0} minutas"
        },
        "past": {
          "one": "{0} minuta retro",
          "other": "{0} minutas retro"
        }
      },
      "minute-narrow": {
        "0": "iste minuta",
        "future": {
          "one": "in {0} min.",
          "other": "in {0} min."
        },
        "past": {
          "one": "{0} min. retro",
          "other": "{0} min. retro"
        }
      },
      "minute-short": {
        "0": "iste minuta",
        "future": {
          "one": "in {0} min.",
          "other": "in {0} min."
        },
        "past": {
          "one": "{0} min. retro",
          "other": "{0} min. retro"
        }
      },
      "month": {
        "-1": "le mense passate",
        "0": "iste mense",
        "1": "le mense proxime",
        "future": {
          "one": "in {0} mense",
          "other": "in {0} menses"
        },
        "past": {
          "one": "{0} mense retro",
          "other": "{0} menses retro"
        }
      },
      "month-narrow": {
        "-1": "mns. pass.",
        "0": "iste mns.",
        "1": "mns. prox.",
        "future": {
          "one": "in {0} mns.",
          "other": "in {0} mns."
        },
        "past": {
          "one": "{0} mns. retro",
          "other": "{0} mns. retro"
        }
      },
      "month-short": {
        "-1": "mns. pass.",
        "0": "iste mns.",
        "1": "mns. prox.",
        "future": {
          "one": "in {0} mns.",
          "other": "in {0} mns."
        },
        "past": {
          "one": "{0} mns. retro",
          "other": "{0} mns. retro"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "le trimestre passate",
        "0": "iste trimestre",
        "1": "le trimestre proxime",
        "future": {
          "one": "in {0} trimestre",
          "other": "in {0} trimestres"
        },
        "past": {
          "one": "{0} trimestre retro",
          "other": "{0} trimestres retro"
        }
      },
      "quarter-narrow": {
        "-1": "le trimestre passate",
        "0": "iste trimestre",
        "1": "le trimestre proxime",
        "future": {
          "one": "in {0} trim.",
          "other": "in {0} trim."
        },
        "past": {
          "one": "{0} trim. retro",
          "other": "{0} trim. retro"
        }
      },
      "quarter-short": {
        "-1": "le trimestre passate",
        "0": "iste trimestre",
        "1": "le trimestre proxime",
        "future": {
          "one": "in {0} trim.",
          "other": "in {0} trim."
        },
        "past": {
          "one": "{0} trim. retro",
          "other": "{0} trim. retro"
        }
      },
      "second": {
        "0": "ora",
        "future": {
          "one": "in {0} secunda",
          "other": "in {0} secundas"
        },
        "past": {
          "one": "{0} secunda retro",
          "other": "{0} secundas retro"
        }
      },
      "second-narrow": {
        "0": "ora",
        "future": {
          "one": "in {0} sec.",
          "other": "in {0} sec."
        },
        "past": {
          "one": "{0} sec. retro",
          "other": "{0} sec. retro"
        }
      },
      "second-short": {
        "0": "ora",
        "future": {
          "one": "in {0} sec.",
          "other": "in {0} sec."
        },
        "past": {
          "one": "{0} sec. retro",
          "other": "{0} sec. retro"
        }
      },
      "week": {
        "-1": "le septimana passate",
        "0": "iste septimana",
        "1": "le septimana proxime",
        "future": {
          "one": "in {0} septimana",
          "other": "in {0} septimanas"
        },
        "past": {
          "one": "{0} septimana retro",
          "other": "{0} septimanas retro"
        }
      },
      "week-narrow": {
        "-1": "sept. pass.",
        "0": "iste sept.",
        "1": "sept. prox.",
        "future": {
          "one": "in {0} sept.",
          "other": "in {0} sept."
        },
        "past": {
          "one": "{0} sept. retro",
          "other": "{0} sept. retro"
        }
      },
      "week-short": {
        "-1": "sept. pass.",
        "0": "iste sept.",
        "1": "sept. prox.",
        "future": {
          "one": "in {0} sept.",
          "other": "in {0} sept."
        },
        "past": {
          "one": "{0} sept. retro",
          "other": "{0} sept. retro"
        }
      },
      "year": {
        "-1": "le anno passate",
        "0": "iste anno",
        "1": "le anno proxime",
        "future": {
          "one": "in {0} anno",
          "other": "in {0} annos"
        },
        "past": {
          "one": "{0} anno retro",
          "other": "{0} annos retro"
        }
      },
      "year-narrow": {
        "-1": "an. pass.",
        "0": "iste an.",
        "1": "an. prox.",
        "future": {
          "one": "in {0} an.",
          "other": "in {0} an."
        },
        "past": {
          "one": "{0} an. retro",
          "other": "{0} an. retro"
        }
      },
      "year-short": {
        "-1": "an. pass.",
        "0": "iste an.",
        "1": "an. prox.",
        "future": {
          "one": "in {0} an.",
          "other": "in {0} an."
        },
        "past": {
          "one": "{0} an. retro",
          "other": "{0} an. retro"
        }
      }
    },
    "locale": "ia"
  });
}